"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.absoluteBuilder = exports.absoluteArrayBuilder = void 0;

var _commonLib = require("@caps-mobile/common-lib");

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var absoluteArrayBuilder = function absoluteArrayBuilder(array) {
  // prevent out of bounds index error by padding in defaults
  if (array.length < 4) array = [].concat(_toConsumableArray(array), ["auto", "auto", "auto", "auto"]);
  return "\n        position: absolute;\n        top: ".concat((0, _commonLib.firstNuon)([array[0], "auto"]), ";\n        right: ").concat((0, _commonLib.firstNuon)([array[1], "auto"]), ";\n        bottom: ").concat((0, _commonLib.firstNuon)([array[2], "auto"]), ";\n        left: ").concat((0, _commonLib.firstNuon)([array[3], "auto"]), ";\n    ");
};

exports.absoluteArrayBuilder = absoluteArrayBuilder;

var absoluteBuilder = function absoluteBuilder(config) {
  var array = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  if (!config) return absoluteArrayBuilder(array);
  var top = (0, _commonLib.firstNuon)([config.top, config.t, "auto"]);
  var right = (0, _commonLib.firstNuon)([config.right, config.r, "auto"]);
  var bottom = (0, _commonLib.firstNuon)([config.bottom, config.b, "auto"]);
  var left = (0, _commonLib.firstNuon)([config.left, config.l, "auto"]);
  return "\n        position: absolute;\n        top: ".concat(top, ";\n        right: ").concat(right, ";\n        bottom: ").concat(bottom, ";\n        left: ").concat(left, ";\n    ");
};

exports.absoluteBuilder = absoluteBuilder;